export default __webpack_public_path__ + "static/media/mke-zoo-jaguar.27cb5248.jpg";